import "./table-loading.scss";

export class TableLoading {

}
